<div class="linkToAngleOrStorySection">
   <div nz-row>
      <div
         nz-col
         nzXs="24"
         class="angleStoryTitle">
         <span>Add to Angle or Story</span>
      </div>
   </div>

   <div class="linkToAngleSection">
      <div
         nz-row
         class="linkToAngle">
         <div
            nz-col
            nzXs="24"
            class="linkToAngleLabel">
            <span>
               Add to Angle
               <i
                  nz-icon
                  nzType="question-circle"
                  nzTheme="outline"
                  nz-tooltip
                  nzTooltipPlacement="topRight"
                  [nzTooltipTitle]="addToAngleToolTipTemplate"
                  class="mr-l-4"></i>
            </span>
         </div>
         <div
            nz-col
            nzXs="24">
            <nz-input-group
               [nzSuffix]="suffixIconSearch"
               class="input-group">
               <input
                  placeholder="Search Angle Name or ID"
                  nz-input
                  [(ngModel)]="angleValue"
                  class="searchText"
                  (keydown)="searchAngle(angleInput.value, $event)"
                  (ngModelChange)="angleMatch($event)"
                  [nzAutocomplete]="autoAngle"
                  #angleInput />
            </nz-input-group>
            <ng-template #suffixIconSearch>
               <span
                  nz-icon
                  nzType="search"
                  class="search-icon"></span>
            </ng-template>
            <nz-autocomplete
               [nzDataSource]="filteredAngleOptions"
               (change)="onEnter($event.target.value)"
               #autoAngle></nz-autocomplete>
         </div>
      </div>

      <div
         *ngIf="relatedAngleTitles"
         class="linkedStoriesSection"
         [class.bottomPad]="relatedAngleTitles.length > 0">
         <ng-container *ngFor="let angle of relatedAngleTitles">
            <div class="angle ant-btn-delete-pad">
               <!-- <button nz-button nzType="default" nzShape="circle" nzSize="small" class="angle-icon-btn">
              <span nz-icon nzType="exclamation" nzTheme="outline" class="draft-icon"></span>
          </button> -->
               <span class="angle-id-text-flex">
                  <div class="angle-id">({{ angle.angleId }})</div>
                  <div class="angle-text">{{ angle.angleTitle }}</div>
               </span>

               <button
                  nz-button
                  nzType="default"
                  class="angle-delete"
                  (click)="deleteRelatedAngles(angle, angle.angleId)">
                  <span
                     nz-icon
                     nzType="delete"
                     nzTheme="outline"
                     class="del-color"></span>
               </button>
            </div>

            <!-- <nz-list-item class="linkedStory" [nzActions]="[opAction]">
            <div class="id"> ({{index.storyId}}) </div>
            <div class="title"> {{index.storyTitle}} </div>
        </nz-list-item>
        <ng-template #opAction>
            <div class="float-del">
                <button nz-button (click)="deletepostRelatedAngles(index, index.storyId)">
                    <span nz-icon nzType="delete" nzTheme="outline" class="del-color"></span>
                </button>
            </div>
        </ng-template> -->
         </ng-container>
      </div>

      <!-- <div *ngIf="relatedStoryTitles" class="linkedStoriesSection"
        [class.bottomPad]="angleRelatedStoryTitles.length > 0">
        <nz-list class="linkedStories cursor" *ngFor="let index of angleRelatedStoryTitles" nzBordered
            nzSize="small">
            <nz-list-item class="linkedStory" [nzActions]="[opAction]">
                <div class="id"> ({{index.storyId}}) </div>
                <div class="title"> {{index.storyTitle}} </div>
            </nz-list-item>
            <ng-template #opAction>
                <div class="float-del">
                    <button nz-button (click)="deletepostRelatedAngles(index, index.storyId)">
                        <span nz-icon nzType="delete" nzTheme="outline" class="del-color"></span>
                    </button>
                </div>
            </ng-template>
        </nz-list>
    </div> -->
   </div>

   <div class="padStoryAngle"></div>

   <div class="linkToStorySection">
      <div
         nz-row
         class="linkToStory">
         <div
            nz-col
            nzXs="24"
            class="linkToStoryLabel">
            <span>
               <span class="mandatory">*</span>
               Add to Story
               <i
                  nz-icon
                  nzType="question-circle"
                  nzTheme="outline"
                  nz-tooltip
                  nzTooltipPlacement="topRight"
                  [nzTooltipTitle]="addToStoryToolTipTemplate"
                  class="mr-l-4"></i>
            </span>
         </div>
         <div
            nz-col
            nzXs="24">
            <nz-input-group
               [nzSuffix]="suffixIconSearch"
               class="input-group">
               <input
                  placeholder="Search Story Name"
                  nz-input
                  [(ngModel)]="value"
                  class="searchText"
                  (keydown)="onChange(storyInput.value, $event)"
                  (ngModelChange)="titleMatch($event)"
                  (keyup.enter)="onEnter($event.target.value)"
                  [nzAutocomplete]="auto"
                  #storyInput />
            </nz-input-group>
            <ng-template #suffixIconSearch>
               <span
                  nz-icon
                  nzType="search"
                  class="searchText"></span>
            </ng-template>
            <nz-autocomplete
               [nzDataSource]="filteredOptions"
               (change)="onEnter($event.target.value)"
               #auto></nz-autocomplete>
         </div>
      </div>

      <!-- Light mode values is {{isLightMode}} -->

      <div
         *ngIf="relatedStoryTitles"
         class="linkedStoriesSection"
         [class.bottomPad]="relatedStoryTitles.length > 0">
         <ng-container *ngFor="let index of relatedStoryTitles">
            <div class="angle">
               <span
                  (click)="postAsPrimaryStory(index.storyId)"
                  [ngClass]="index.isPrimary ? 'primary-crown' : 'crown'">
                  <span
                     nz-icon
                     nzType="crown"
                     class="crownSize"></span>
               </span>

               <span class="story-text">
                  <div>{{ index.storyTitle }}</div>
               </span>

               <span
                  *ngIf="isLightMode"
                  class="angle-delete">
                  <button
                     *ngIf="functionAbility.fa_pin_post"
                     nz-button
                     nzType="default"
                     nzShape="circle"
                     [ngClass]="index.isPinnedOnTop ? 'push-pin' : ''"
                     (click)="pinStory(index.storyId, isPinnedOnTop)">
                     <span
                        nz-icon
                        nzType="pushpin"
                        [nzTheme]="index.isPinnedOnTop ? 'fill' : 'outline'"></span>
                  </button>
               </span>

               <span
                  *ngIf="!isLightMode"
                  class="angle-delete"
                  [ngClass]="index.isPinnedOnTop ? 'have-btn-border' : ''">
                  <button
                     *ngIf="functionAbility.fa_pin_post"
                     nz-button
                     nzType="default"
                     nzShape="circle"
                     [ngClass]="index.isPinnedOnTop ? 'push-pin-dark' : ''"
                     (click)="pinStory(index.storyId, isPinnedOnTop)">
                     <span
                        nz-icon
                        nzType="pushpin"
                        nzTheme="outline"></span>
                  </button>
               </span>

               <span
                  class="ml-8"
                  [ngClass]="!functionAbility.fa_pin_post ? 'angle-delete' : ''">
                  <button
                     nz-button
                     (click)="deleteRelatedStories(index, index.storyId)">
                     <span
                        nz-icon
                        nzType="delete"
                        nzTheme="outline"
                        class="del-color"></span>
                  </button>
               </span>
            </div>

            <!-- <nz-list class="linkedStories cursor" *ngFor="let index of relatedStoryTitles" nzBordered
            nzSize="small">
            <nz-list-item class="linkedStory" [nzActions]="[opAction]">
                <div class="leftBtns">
                    <button nz-button (click)="postAsPrimaryStory(index.storyId)"
                        [ngClass]="(index.isPrimary) ? 'primary-crown' : 'crown'">
                        <i nz-icon nzType="crown" class="crownSize"></i>
                    </button>
                    <span class="title">{{index.storyTitle}}</span>
                </div>
            </nz-list-item>
            <ng-template #opAction>
                <div class="rightBtns">
                    <nz-button-group>
                        <button *ngIf="functionAbility.fa_pin_post" nz-button nzType="default" nzShape="circle"
                            [ngClass]="index.isPinnedOnTop ? 'push-pin':''"
                            (click)="pinStory(index.storyId, isPinnedOnTop)">
                            <span nz-icon nzType="pushpin"
                                [nzTheme]="index.isPinnedOnTop ? 'fill' : 'outline'"></span>
                        </button>
                        <button nz-button (click)="deleteRelatedStories(index, index.storyId)">
                            <span nz-icon nzType="delete" nzTheme="outline" class="del-color"></span>
                        </button>
                    </nz-button-group>
                </div>
            </ng-template>
        </nz-list> -->
         </ng-container>
      </div>

      <div nz-row>
         <div
            nz-col
            nzXs="24"
            class="crownInfo">
            <span>
               <i
                  nz-icon
                  nzType="info-circle"
                  class="crown-icon"
                  nzTheme="fill"></i>
               To change the “Main” Story click the crown
            </span>
         </div>
      </div>
   </div>
</div>

<ng-template #addToAngleToolTipTemplate>
   <span class="tool-tip">Search by angle name or ID. You can add this post to multiple angles</span>
</ng-template>

<ng-template #addToStoryToolTipTemplate>
   <span class="tool-tip">Search by story name. You can add this post to multiple stories</span>
</ng-template>
